import React, { Component } from 'react'
import { Logo } from '../../components/Layout'
import { LoginForm } from './components'

export default class extends Component {
  render () {
    const { getUser, authorizeAdmin, auth } = this.props

    return (
      <div className='login app__login'>
        <div className='login__container'>
          <div className='login__wrapper'>
            <div className='login__logo'>
              <Logo width='64' />
            </div>
              <div className='login__content'>
                <LoginForm
                  authorizeAdmin={authorizeAdmin}
                  getUser={getUser}
                  auth={auth} />
              </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Secure/Secure.jsx